import React from 'react'

import { Container } from '@mui/joy'

import i18n from '@/i18n'

export default function PromotionPage() {
  return (
    <Container>
      <h3>{i18n.t('promotion')}</h3>
    </Container>
  )
}